// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".secondary-button[data-v-4564dce4]{min-height:48px;text-transform:lowercase}.secondary-button .v-list-item-title[data-v-4564dce4]{text-transform:inherit}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
